/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Badge, Table,
} from 'antd';
import {
  CaretRightFilled,
} from '@ant-design/icons';
import SoActions from '@Actions/sales/soActions';
import imageDefault from '@Images/icons/imageDefault.png';
import './style.scss';
import { QUANTITY } from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';

/**
 * RefundLines component
 *
 * @param record
 * @param file
 */
function RefundLines({
  selectedSO, cancelReturnFulfillmentLoading, getReturnsLoading, MONEY,
}) {
  const returnFulfilledColumns = [
    {
      title: '',
      width: '60px',
      render: (record) => ({
        props: { style: { backgroundColor: !record?.id ? '#ABE09835' : 'white' } },
        children: (
          <Fragment>

            {record?.id ? (
              <div style={{ width: '50px', height: '50px' }}>

                <img style={{ width: '50px', height: '50px', opacity: record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? 1 : 0.15 }} src={`${record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url : imageDefault}`} />
                <Badge
                  className="fulfilled-qty__badge"
                  count={QUANTITY(record?.quantity, record?.tenant_product_info?.product_sku_info?.uom_info?.[0]?.precision)}
                />
              </div>
            ) : (
              <div className="rl-table__location-wrapper">
                <div className="rl-table__fg-name">

                  {`Refund #${record?.ffId}`}
                  {' '}
                  <CaretRightFilled />
                </div>
                <div>
                  {MONEY(Helpers.getValueTotalInObject(record?.transaction, 'amount'))}
                </div>
              </div>
            )}
          </Fragment>),
      }),
      onCell: (item) => {
        if (!item?.id) {
          return { colSpan: 7 };
        }
        return {};
      },
    },
    {
      title: 'PRODUCT',
      render: (item) => (
        <Fragment>

          <div className="fulfilled__product-info__wrapper">
            <div className="fulfilled__product-info">
              <Link
                to={`/inventory/product/view/${item?.tenant_product_info?.product_sku_info?.product_sku_id}`}
                target="_blank"
              >
                <span style={{ fontSize: '11px' }}>
                  #
                  {item?.tenant_product_info?.product_sku_info?.internal_sku_code}
                </span>
              </Link>
              <br />
              {item?.tenant_product_info?.product_sku_info?.product_sku_name}
              <H3Text text={item.remarks} className="quotation__remarks" />
            </div>
            <div className="fulfilled__product-pricing">
              {`${QUANTITY(item?.quantity, item?.tenant_product_info?.product_sku_info?.uom_info?.[0]?.precision)} ${item?.tenant_product_info?.product_sku_info?.uom_info?.uqc?.toProperCase() || ''}`}

            </div>
          </div>
        </Fragment>
      ),
      onCell: (item) => {
        if (!item?.id) {
          return { colSpan: 0 };
        }
        return { colSpan: 6 };
      },
    },

  ];

  /**
   *
   * @param {*} data
   * @return
   */
  const getDataSource = (data) => {
    const finalLines = [];
    if (data?.shopify_refunds) {
      data?.shopify_refunds.map((uf) => {
        const lines = uf.refund_lines;
        const fulfillmentId = uf.refund_id;
        const shopifyFulfillmentId = uf.shopify_refund_id;
        finalLines.push({
          ffId: fulfillmentId,
          shopifyFulfillmentId,
          transaction: uf.transaction,
        });
        lines.map((line) => finalLines.push({
          ...line, ...line.tenant_info, id: line?.tenant_id, key: uuidv4(),
        }));
        // return uf;
      });
    }
    return finalLines;
  };

  return (
    <Fragment>
      <div className="view-so-rl-table-wrapper">
        <Table
          showHeader
          title={() => `Refunds (${getDataSource(selectedSO)?.filter((item) => item?.id)?.length || 0})`}
          loading={cancelReturnFulfillmentLoading || getReturnsLoading}
          size="small"
          columns={returnFulfilledColumns}
          dataSource={getDataSource(selectedSO)}
          pagination={false}
          bordered
          scroll={{ x: true }}

        />
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ SOReducers, UserReducers }) => ({
  MONEY: UserReducers.MONEY,
  cancelReturnFulfillment: SOReducers.cancelReturnFulfillment,
  cancelReturnFulfillmentLoading: SOReducers.cancelReturnFulfillmentLoading,
  getReturnsLoading: SOReducers.getReturnsLoading,
  selectedSO: SOReducers.selectedSO,

});

const mapDispatchToProps = (dispatch) => ({
  cancelReturnFulfillment: (payload, callback) => dispatch(SoActions.cancelReturnFulfillment(payload, callback)),
  getReturns: (shopName, shopifyOrderId, orderId) => dispatch(SoActions.getReturns(shopName, shopifyOrderId, orderId)),

});

RefundLines.propTypes = {
  selectedSO: PropTypes.any,
  cancelReturnFulfillmentLoading: PropTypes.bool,
  getReturnsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RefundLines));
